<template>
    <div>
        <div class="flex-row d-flex flex-wrap align-items-center">
            <div :class="{ 'col-lg-8 mb-4': !options.graphView, 'col-12 mb-2': options.graphView }">
                <div class="row">
                    <h1 class="float-left" v-if="!node.id">{{ $t("add-node") }}</h1>
                    <h1 class="float-left" v-else-if="node.title">
                        {{ node.title }}
                    </h1>
                    <div class="skeleton midnight h32 w-half" v-else></div>
                </div>
                <div class="flex-row d-flex justify-content-end" v-if="options.nodeLinks">
                    <h3>
                        <button class="btn btn-outline-primary" 
                            @click="$router.push(`/curriculum-mapping/node/${node.id}/detail`)"
                        >
                            <b-icon icon="info-circle-fill" width="1em" height="1em" class="ml-2" /> {{ $t('detail')}}
                        </button>
                        <button class="btn btn-outline-primary ml-1" 
                            @click="$router.push(`/curriculum-mapping/node/${node.id}/graph`)"
                        >
                            <b-icon icon="zoom-in" width="1em" height="1em" class="ml-2" /> {{ $t('zoom')}}
                        </button>
                    </h3>
                </div>
                <div 
                    v-if="editing && options.spareChildrenNodes && node.children && node.children.length > 0 && $UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
                    class="row d-flex justify-content-end">
                    <CheckboxInput v-if="node.children.length > 0 && node.parent_id !== null" :value="spare_children"
                        @input="spare_children = !spare_children" :label="$t('spare-children')" />
                    <small v-if="spare_children" class="text-muted">{{ $t('spare-children-text') }}</small>
                </div>
            </div>
            <div class="d-flex justify-content-end" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
                :class="{ 'col-lg-4 mb-4': !options.graphView, 'col-12 mb-2': options.graphView }">
                <button v-if="editing" class="btn btn-primary float-right ml-4 mb-2"
                    @click="saveNode(node, node.absolute_parent_id, node.root_id)" :disabled="!node.title">
                    {{ $t("save") }}
                </button>
                <button v-if="editing && node.id" class="btn btn-danger float-right ml-1  mb-2"
                    @click="deleteNode(node)">
                    {{ $t("delete") }}
                </button>
                <button v-if="editing && node.id" class="btn btn-secondary float-right ml-1 mb-2"
                    @click="editing = false">
                    {{ $t("cancel") }}
                </button>
                <div class="btn-group" v-if="!editing">
                    <button class="btn btn-primary float-right mb-2" @click="editing = true">
                        {{ $t("edit") }}
                    </button>
                    <button 
                        v-if="node"
                        class="btn btn-success float-right mb-2" 
                        @click="transmuting = true;">
                        {{ $t('copy-move') }} 
                    </button>
                </div>
                            
            </div>
        </div>
        <!--div class="row" v-if="error">
            <div class="col-12">
                <b-alert variant="danger" show>{{ error }}</b-alert>
            </div>
        </div-->
        <div class="row" v-if="options.breadcrumbs">
            <div class="col-12">
                <b-breadcrumb>
                    <b-breadcrumb-item v-for="node in path" :key="node.id"
                        :active="node.parent_id == null && node.absolute_parent_id !== null"
                        :href="`/curriculum-mapping/node/${node.id}/detail`">
                            {{ node.title }}
                    </b-breadcrumb-item>
                </b-breadcrumb>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-12 col-lg-6 mb-2">
                <TextInput :label="$t('title')" v-model="node.title" v-if="editing" />
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("title") }}</label>
                    <p class="mb-0">
                        {{ node.title !== null ? node.title : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
            <div class="col-sm-12 col-lg-6 mb-2">
                <SelectInput v-if="editing" v-model="node.curriculumcomponenttype_id" :options="components"
                    optionLabel="title" optionValue="id" :label="$t('component')" class="font-bold">
                </SelectInput>
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("component") }}</label>
                    <p class="mb-2">
                        {{ component !== null ? component.title : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12">
                <TextAreaInput v-if="editing" v-model="node.note" :label="$t('notes')" class="font-bold" />
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("notes") }}</label>
                    <p class="mb-0">
                        {{ node.note ? node.note : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <Table v-if="node.children && node.children.length > 0 && options.displayChildren"
                    :loading="!node.children" 
                    :submitting="submitting" 
                    :cols="tableCols" 
                    :data="node.children"
                    breakpoint="md" 
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                    }" 
                    :searchable="false" 
                    :scrollPaginate="true" 
                    @refresh="refresh"
                    @selectItem="children_node => $router.push(`/curriculum-mapping/node/${children_node.id}/detail`)"
                    :allowRightClick="true"
                    @deleteItem="children_node => deleteNode(children_node)"
                >
                    <template v-slot:header>
                        <h2>{{ $t('nodes') }}</h2>
                    </template>
                </Table>
            </div>
        </div>
        <div class="col-12" style="padding-right:0px;">
            <div class="d-flex justify-content-end" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button v-if="options.newNodeEditor"
                        class="btn ml-auto"
                        :class="addingNewNode ? 'btn-secondary' : 'btn-primary'" 
                        @click="addingNewNode = !addingNewNode"
                    >
                    <b-icon v-if="!addingNewNode" icon="plus" class="h6 mb-0 mr-1"/>{{ addingNewNode ? $t('done') : $t('add-node') }}
                </button>
            </div>
            <!-- START Add New Node-->
            <div class="row">
                <div class="col-12">
                    <div class="card mb-2 mt-2" v-if="addingNewNode">
                        <h5 class="card-header">{{ $t('add-new-children-node') }}</h5>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <TextInput v-model="newNode.title" :label="$t('title')" class="font-bold" />
                                </div>
                                <div class="col-12">
                                    <SelectInput v-model="newNode.curriculumcomponenttype_id" :options="components"
                                        optionLabel="title" optionValue="id" :label="$t('component')" class="font-bold" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <TextAreaInput v-model="newNode.note" :label="$t('notes')" class="font-bold" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button class="btn btn-outline-primary float-right"
                                        @click="saveNode(newNode, node.id, node.root_id)">
                                        {{ $t('add-node') }}
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="font-bold">{{ $t('learning-outcomes') }}</h3>
                                    <LearningOutcomesMapper v-model="newNode.learningoutcomes" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END Add New Node-->
        </div>
        <div class="row d-flex justify-content-end mt-2">
            <CheckboxInput :value="linked_outcomes" @input="linked_outcomes = !linked_outcomes"
                :label="$t('display-linked-outcomes')" />
        </div>
        <LearningOutcomesMapper v-if="options.learningOutcomes" 
            v-model="nodeLearningOutcomes"
            @doneEditing="saveLearningOutcomes"
            :viewOnly="!$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
            :defaultlearningoutcomes="learningoutcomes"
            :defaultGroups="defaultGroups"
        >
            <template v-slot:label>
                <h2>{{ $t('learning-outcomes') }}</h2>
            </template>
        </LearningOutcomesMapper>
        <TransmuteHierarchy 
            :show="transmuting"
            :sending="saving"
            :node="node"
            @action="(action) => handleTransmutation(action)"
        />
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import CheckboxInput from "src/components/Inputs/CheckboxInput.vue"
import CurriculumMap from 'src/modules/curriculummap.js'
import LearningOutcomes from 'src/modules/learningoutcomes.js'
import TransmuteHierarchy from "./TransmuteHierachy.vue";

export default {
    props: {
        options: Object,
        node: Object,
        viewOnly: Boolean, 
        defaultGroups: {
            type: Array,
            default: () =>[]
        },
        defaultlearningoutcomes: {
            type: Array,
            default: () =>[]
        }
    },
    components: {
        Table,
        LearningOutcomesMapper,
        CheckboxInput,
        TransmuteHierarchy
    },
    data: function () {
        return {
            error: null,
            //loaded: false,
            editing: false,
            nodes: [],
            spare_children: false,
            newNode: {},
            submitting: false,
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                search: '',
            },
            components: [],
            learningoutcomes: [],
            path: [],
            dendoWrapperStyle: "position: fixed; top: 0px; bottom:0; left: 0; right:10px; overflow: hidden;",
            addingNewNode: false,
            transmuting: false,
            saving: false,
            linked_outcomes: false
        };
    },
    mounted() {
        this.getComponents();
        
        this.learningOutcomes = new LearningOutcomes();

        if(!this.defaultlearningoutcomes || this.defaultlearningoutcomes.length == 0){
            this.learningOutcomes.list()
            .then((res) => this.learningoutcomes = res.results );
        } else this.learningoutcomes = this.defaultlearningoutcomes


        this.current_node = new CurriculumMap(this.node.id);

        if (this.options.breadcrumbs){
            this.current_node.getNodes({
                parent_id: null,
                just_roots: false,
                path_in_string: false
            }).then(
                (res) => this.path = res.filter(item => item.id == this.$route.params.id)[0].path
            )
        }

        // if (!this.node.learningoutcomes?.original_obj && this.node.learningoutcomes?.original) {
        //     const original = this.node.learningoutcomes.original || [];
        //     const linked = this.node.learningoutcomes.linked || [];
            
        //     this.$set(this.node.learningoutcomes, 'original_obj', 
        //         this.learningoutcomes.filter(obj => original.includes(obj.id)));
                
        //     const joint_ids = [...original, ...linked];
        //     this.$set(this.node.learningoutcomes, 'joint_obj',
        //         this.learningoutcomes.filter(obj => joint_ids.includes(obj.id)));
        // }
        
    },
    
    methods: {
        /**
        * Saves a node. If there are parent_id and/or root_id, it is saved as a children of the that parent node with that root.
        *
        * @param {Object} node - The node chosen from the hierarchy.
        * @param {string} parent_id - The id of the parent node.
        * @param {string} root_id - The id of the root node.
        * @param {string} action - Transmutation action, can be 'copy' or 'move'.
        */
        saveNode(node, parent_id = null, root_id = null, action = null) {
            this.saving = true;

            let newChild = false;
            return this.current_node.saveNode(node, parent_id, root_id, action)
            .then((res)=> {
                let apiNode = res.node
                newChild = res.newChild
                /** 
                * This fixes the learning outcomes for the mapper, as it 
                * only accepts Arrays of objects
                */
                if (apiNode.learningoutcomes.length > 0 ) {
                    const node_learningoutcomes = apiNode.learningoutcomes;

                    apiNode.learningoutcomes = {};

                    apiNode.learningoutcomes.linked = node.learningoutcomes?.linked ? node.learningoutcomes.linked : [];
                    apiNode.learningoutcomes.original = node_learningoutcomes.map(item => item.id);


                    const joint_ids = [
                        ...apiNode.learningoutcomes.original,
                        ...apiNode.learningoutcomes.linked
                    ]

                    apiNode.learningoutcomes.joint = this.learningoutcomes.filter(obj => joint_ids.includes(obj.id))
                
                }

                let selectedNode = {};
                if (newChild) {
                    selectedNode = this.node;
                    selectedNode.children.push(apiNode);
                } else {
                    selectedNode = apiNode;
                }

                this.$emit('nodeChanges', {
                    action: newChild ? 'node_added' : 'node_saved',
                    data: selectedNode
                })

                return res

            })
            .catch(error => {
                this.$log.error.call(this, error);
                this.saving = false
            }).finally(() => {
                if (newChild){ 
                    this.newNode = {}
                } else {
                    this.editing = false;
                }
                this.saving = false;
            });
        },
        deleteNode(node) {
            if (!node.parent_id) { // Selected node is the root, cannot be deleted
                this.$store.commit("openDialog", {
                    title: this.$t("oops"),
                    content: this.$t("you-can-not-delete-the-root")
                });

                return;
            }

            const data_to_delete = {
                id: node.id,
                spare_children: this.spare_children,
                parent_id: node.parent_id
            }

            this.current_node.deleteNode(data_to_delete)
            .then((status) => {
                if (status === 'SUCCESS') {
                    this.$emit('nodeChanges', {
                        action: 'node_deleted',
                        data: data_to_delete
                    })
                }
            })
            .finally(() => {
                this.newNode = {};
                this.editing = false;
            })
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
        },
        getComponents() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/list`, {
                method: 'post'
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.components = res.results;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        },

        getComponentTitle(id) {
            if (this.components.filter(obj => id == obj.id).length > 0) {
                return this.components.filter(obj => id == obj.id)[0].title;
            }
            return null;
        },
   
        saveLearningOutcomes(doneEditing) {
            if(doneEditing){
                let node = {
                    ...this.node,
                    learningoutcomes: this.nodeLearningOutcomes
                }

                this.saveNode(node,node.absolute_parent_id,node.root_id)
            }
        },
        handleTransmutation(payload) {

            if(payload.action === 'close'){ 
                this.transmuting = false;
                return ;
            }

            this.saveNode(
                this.node, 
                payload.target_node.id, 
                payload.target_node.root_id,
                payload.action === 'copy' ? 'copy' : null
            ).then(() => this.transmuting = false)
        }
    },
    computed: {
        component() {
            if (this.components && this.node.curriculumcomponenttype_id) {
                return this.components.filter(obj => this.node.curriculumcomponenttype_id == obj.id);
            }
            return null;
        },
        tableCols() {
            let cols = [
                { key: 'title', heading: this.$t('name'), size: this.options.graphView ? 6 : 4 },
                {
                    key: 'curriculumcomponenttype_id', heading: this.$t('component'), size: this.options.graphView ? 6 : 4,
                    cb: (node) => this.getComponentTitle(node.curriculumcomponenttype_id)
                },
            ]

            if (!this.options.graphView) cols.push({ key: 'note', heading: this.$t('notes'), size: 4 });

            return cols;
        },
        nodeLearningOutcomes: {
            get() {
                // Ensure learningoutcomes exists with proper structure
                if (!this.node.learningoutcomes) {
                    this.$set(this.node, 'learningoutcomes', {
                        original_obj: [],
                        joint_obj: []
                    });
                }
                return this.linked_outcomes 
                    ? this.node.learningoutcomes.joint_obj || []
                    : this.node.learningoutcomes.original_obj || [];
            },
            set(value) {
                if (!this.node.learningoutcomes) {
                    this.$set(this.node, 'learningoutcomes', {
                        original_obj: [],
                        joint_obj: []
                    });
                }
                if (this.linked_outcomes) {
                    this.$set(this.node.learningoutcomes, 'joint_obj', value);
                } else {
                    this.$set(this.node.learningoutcomes, 'original_obj', value);
                }
            }
        }

    },
};
</script>
